// extracted by mini-css-extract-plugin
export default {"input":"SectionedInput_input__EwT23"};